import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import moment from 'moment-timezone';
import appointmentService from '../../../services/appointment';
import tableMixin from '../../../Mixins/table';
import appointmentMixin from '../../../Mixins/appointment';
import stringUtil from '../../../utils/stringUtil';
import numberUtil from '../../../utils/number';
import dateTimeUtil from '../../../utils/dateTime';

export default Vue.extend({
  store,
  mixins: [tableMixin, appointmentMixin],
  data: () => {
    return {
      filter: {
        page: 1,
        itemsPerPage: 30,
        start: moment().format('Y-MM-DD'),
        end: null,
        status: [],
        type: [],
        location: [],
        order: 'asc',
        sort: 'due',
        sortTable: false,
        search: null,
      },
      // search:null,
      totalPages: 0,
      sortOptions: [
        {
          text: 'DUE',
          value: 'due',
        },
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'CREATE AT',
          value: 'created_at',
        },
      ],
      orderOptions: [
        {
          text: 'ASCENDING',
          value: 'asc',
        },
        {
          text: 'DESCENDING',
          value: 'desc',
        },
      ],
      statusOptions: [
        {
          text: 'PENDING',
          value: 'pending',
        },
        {
          text: 'ON GOING',
          value: 'ongoing',
        },
        {
          text: 'COMPLETED',
          value: 'completed',
        },
        {
          text: 'CANCELED',
          value: 'cancelled',
        },
        {
          text: 'INCOMPLETE',
          value: 'incomplete',
        },
        {
          text: 'PAYMENT PROCESSING',
          value: 'payment_processing',
        },
        {
          text: 'PAYMENT EXPIRED',
          value: 'payment_expired',
        },
        {
          text: 'CHARGE_ERROR',
          value: 'chargeError',
        },
      ],
      typeOptions: [
        {
          text: 'WALK-IN',
          value: 'walkin',
        },
        {
          text: 'APPOINTMENT',
          value: 'appointment',
        },
      ],
      locationOptions: [
        {
          text: 'Online',
          value: 0,
        },
        {
          text: 'Gaysorn',
          value: 1,
        },
      ],
      //loadingAppointments: false,
      appointments: [],
      upcomingAppointments: [],
      upcomingHeaders: [
        { text: 'ID', align: 'center', value: 'id', sortable: false },
        { text: 'Appointed At (Bangkok Time)', align: 'center', value: 'bangkok_time', sortable: false },
        { text: 'Status', align: 'center', value: 'status', sortable: false },
        { text: 'Wait', align: 'center', value: 'wait', sortable: false },
        { text: 'Last Wait', align: 'center', value: 'last_wait', sortable: false },
        { text: 'Provider Wait', align: 'center', value: 'provider_wait', sortable: false },
        { text: 'Provider Last Wait', align: 'center', value: 'provider_last_wait', sortable: false },
      ],
      totalAppointment: null,
      appointmentHeaders: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Patient',
          align: 'center',
          value: 'patient_profile.firstname',
          sortable: false,
        },
        {
          text: 'Provider',
          align: 'center',
          value: 'provider_profile.firstname',
          sortable: false,
        },
        {
          text: 'Location',
          align: 'center',
          value: 'location',
          sortable: true,
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
          sortable: true,
        },
        {
          text: 'Type',
          align: 'center',
          value: 'type',
          sortable: true,
        },
        {
          text: 'Due',
          align: 'center',
          value: ' appointed_at',
          sortable: true,
        },
        {
          text: 'Reserved Time',
          align: 'center',
          value: 'reserved_duration',
          sortable: true,
        },
        {
          text: 'Submit Draft',
          align: 'center',
          value: 'draft',
          sortable: true,
        },
        {
          text: 'Start',
          align: 'center',
          value: 'start',
          sortable: false,
        },
        {
          text: 'End',
          align: 'center',
          value: 'end',
          sortable: false,
        },
        {
          text: 'Duration (Min)',
          align: 'center',
          value: 'duration_string',
          sortable: false,
        },
        {
          text: 'Price (Per Session)',
          align: 'center',
          value: 'price_rate',
          sortable: false,
        },
        {
          text: 'Net Price',
          align: 'center',
          value: 'price_detail.net_price',
          sortable: false,
        },
        {
          text: 'Price',
          align: 'center',
          value: 'price_detail.total',
          sortable: false,
        },
        {
          text: 'Use Coupon',
          align: 'center',
          value: 'new_coupon.code',
          sortable: false,
        },
        {
          text: 'Discount',
          align: 'center',
          value: 'price_detail.discount_price',
          sortable: false,
        },
        {
          text: 'OOCA Gain',
          align: 'center',
          value: 'price_detail.ooca_service',
          sortable: false,
        },
        {
          text: 'Provider Gain',
          align: 'center',
          value: 'price_detail.provider',
          sortable: false,
        },
        {
          text: 'Walk-in Fee (ooca/provider)',
          align: 'center',
          value: 'price_detail.walkin_fee',
          sortable: false,
        },
        {
          text: 'Created At',
          align: 'center',
          value: 'created_at',
          sortable: false,
        },
        {
          text: 'Action',
          align: 'center',
          value: 'id',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    stringUtil() {
      return stringUtil;
    },
    numberUtil() {
      return numberUtil;
    },
    dateTimeUtil() {
      return dateTimeUtil;
    },
  },
  watch: {
    filter: {
      handler() {
        this.getAppointmentList().then((data) => {
          console.log('call', data);
          this.appointments = data.items;
          this.totalAppointment = data.total;
          this.totalPages = data.totalPages;
        });
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getAppointmentList().then((data) => {
      console.log('call', data);
      this.appointments = data.items;
      this.totalAppointment = data.total;
      this.totalPages = data.totalPages;
    });
    this.getUpcomingAppointments();
  },
  methods: {
    calculateProviderGain(price_detail) {
      return numberUtil.commaWithDecimal(price_detail.provider, 2);
    },
    calculateNetPrice(priceDetail) {
      const { total, fee_gateway } = priceDetail;
      return numberUtil.commaWithDecimal(total + fee_gateway, 2);
    },
    calculatePrice(priceDetail) {
      const { total } = priceDetail;
      return numberUtil.commaWithDecimal(total, 2);
    },
    toBangkokTime(ts) {
      if (!ts) return '-';
      return moment.utc(ts).add(7, 'hours').format('YYYY-MM-DD HH:mm');
    },
    getUpcomingAppointments() {
      const query = {
        per_page: 100,
        page: 1,
        sort: 'asc',
        order: 'due',
        due_start: moment.utc().subtract(1.5, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      };
      appointmentService
        .all(query)
        .then((data) => {
          this.upcomingAppointments = data.data;
        })
        .catch((err) => {
          console.error('Failed to fetch upcoming appointments', err);
        });
    },
    getAppointmentList() {
      //this.loadingAppointments = true;
      return new Promise((resolve, reject) => {
        let query = {};
        query.per_page = this.filter.itemsPerPage;
        query.page = this.filter.page;

        // if (this.filter.sort) query.sort = this.filter.sort;
        // if (this.filter.order) query.order = this.filter.order;
        // if (this.filter.search) query.search = this.filter.search;
        // if (this.filter.start) query.start = this.filter.start;
        // if (this.filter.end) query.end = this.filter.end;
        // if (this.filter.status) query.status = this.filter.status;
        // if (this.filter.type) query.type = this.filter.type;

        let filterStatus = [...this.filter.status];
        let filterType = [...this.filter.type];
        let locationType = [...this.filter.location];
        query.sort = this.filter.sortTable ? 'desc' : 'asc';
        query.order = 'due';
        if (this.filter.search) query.q = this.filter.search;
        if (this.filter.start) query.due_start = dateTimeUtil.formatDateTimeForPayload(this.filter.start);
        if (this.filter.end) query.due_end = dateTimeUtil.formatDateTimeForPayload(this.filter.end);
        if (filterStatus.length) query.statuses = filterStatus.join(',');
        if (filterType.length) query.types = filterType.join(',');
        if (locationType.length) query.locations = locationType.join(',');

        appointmentService
          .all(query)
          .then((data) => {
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            // const totalPages = meta.pagination.total_pages;
            const totalPages = meta.pagination.last_page;
            //this.loadingAppointments = false;
            resolve({
              items,
              total,
              totalPages,
            });
          })
          .catch((err) => {
            //this.loadingAppointments = false;
            reject(err);
          });
      });
    },
  },
});
